// @flow
import * as React from 'react';

// Utils
import { getMetaTagContentByName } from 'utils/DOM';

type Props = {||};

export const withEasterEgg = (WrappedComponent: any) =>
  class WithEasterEgg extends React.Component<Props> {
    componentDidMount() {
      document.addEventListener('keydown', this.listenKeyboard, true);
    }

    listenKeyboard(event: KeyboardEvent) {
      // easter egg to show app info when pressing: ctrl + shift + v
      if (event.ctrlKey && event.shiftKey && event.keyCode === 86) {
        const appInfo = `
      Branch: ${getMetaTagContentByName('xtime:gitBranch')}
      Release Number: ${getMetaTagContentByName('xtime:releaseNumber')}
      Build Number: ${getMetaTagContentByName('xtime:buildNumber')}`;
        // eslint-disable-next-line no-alert
        alert(appInfo);
      }
    }

    render() {
      return <WrappedComponent />;
    }
  };



// WEBPACK FOOTER //
// ./src/components/common/decorators/easterEgg/EasterEgg.js